import React from 'react'

import PropTypes from 'prop-types'
import configpath from 'configpath'

import { Link, browserHistory } from 'react-router'

const InvitedCreators = (props) => {
  const host = configpath.wisp_public_url
  return (
    <div className="col-md-12" style={{ marginTop: '0px', padding: '0' }}>
      <div className="portlet-title">
        <h4 style={{ fontWeight: 'bold' }}>Invited Creators ({props.invitedCreators.length})</h4>
        <h5 className="pull-left">
          {`No. of creators who submitted pitch: (${props.invitedCreators.filter(
            creator => props.pitchRows.find(row => row.name === creator.name,
            )).length})`}
        </h5>
        <button
          type="button"
          className="btn blue btn-outline pull-right"
          onClick={() => browserHistory.push(`/projects/${props.projectId}/summary`)}
          style={{ marginBottom: '10px', borderRadius: '4px' }}
        >
          Go To Pitches Summary
        </button>
      </div>
      <div className="table-scrollable table-scrollable-borderless" style={{ maxHeight: '400px', overflowY: 'auto' }}>
        <table className="table table-hover table-light">
          <tbody>
            <tr>
              <th>Creators</th>
              <th>Status</th>
              <th>View Pitch</th>
              <th>Phone No.</th>
              <th>Project Inv. Link</th>
            </tr>
            {props.invitedCreators.map(creator => (
              <tr key={creator.detailId}>
                <td>
                  <Link target="_blank" to={`/profiles/${creator.profileId}`}>{creator.name}</Link>
                </td>
                <td>
                  {creator.status}
                </td>
                <td width={190}>
                  {props.pitch.map(each => (
                    each.profile.id === creator.id &&
                    <Link
                      key={each.id}
                      to={`/projects/${props.projectId}/pitch/${each.id}`}
                    >
                      <p>
                        View {`(${each.orderDetail.productName})`}
                      </p>
                    </Link>
                  ),
                  )}
                </td>
                <td>
                  {creator.phoneNumber ? creator.phoneNumber : '-'}
                </td>
                <td>
                  {`${host}/${creator.profileId}/project/${props.projectId}/order`}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

InvitedCreators.propTypes = {
  invitedCreators: PropTypes.arrayOf(PropTypes.object).isRequired,
  projectId: PropTypes.string.isRequired,
}


export default InvitedCreators
